export const videoTestPublicUrl = 'https://wwwresstatic.vivo.com.cn/vivoportal/files/resource/files/1727149256445/'
export const videoPrePublicUrl = 'https://wwwresstatic.vivo.com.cn/vivoportal/files/resource/files/1727149256445/'
export const videoPrdPublicUrl = ''

export const VIDEO_HOST = videoPrePublicUrl

export const fontDownloadUrl = 'https://h5.vivo.com.cn/pcvivo/OS5-font/vivo Sans.zip'